export const CLIMATE_PRODUCT_NAMES = {
  PLUS: 'FieldView Plus',
  PLUS_DEMO: 'FieldViewPlusDemo',
  PREMIUM: 'FieldView Premium',
  PRIME: 'Prime',
  PRO: 'ClimatePro'
};

export const SSURGO = 'ssurgo';

export const KEYS_BY_PRODUCT = {
  [CLIMATE_PRODUCT_NAMES.PLUS]: 'plus',
  [CLIMATE_PRODUCT_NAMES.PREMIUM]: 'premium',
  [CLIMATE_PRODUCT_NAMES.PRO]: 'pro'
};

export const FEATURE_NAMES = {
  ADVANCED_SCRIPTING: 'AdvancedScripting',
  MANUAL_SCRIPTING: 'ManualScripting',
  YIELD_ANALYSIS: 'YieldAnalysis'
};
